module.exports = __webpack_public_path__ + "static/innovation.92a09d58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awards_ceremony/innovation.png
// module id = 556
// module chunks = 138584234813021